import {Component, Input} from '@angular/core';
import {CommonSvgIconsComponent} from "../../../../shared/components/common-svg-icons/common-svg-icons.component";
import {NgForOf, NgIf} from "@angular/common";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {TagInputModule} from "ngx-chips";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {GeneralService} from "../../../../core/services/general.service";
import {TableService} from "../../../../core/services/table.service";
import {RoutesService} from "../../../../core/services/routes.service";
import {BillingService} from "../../../../core/services/billing.service";
import {ConfirmComponent} from "../../../../shared/components/generalModals/confirm/confirm.component";
import {AuthService} from "../../../../core/services/auth.service";

@Component({
  selector: 'app-new-billing',
  standalone: true,
    imports: [
        CommonSvgIconsComponent,
        NgForOf,
        NgIf,
        ReactiveFormsModule,
        TagInputModule
    ],
  templateUrl: './new-billing.component.html',
  styleUrl: './new-billing.component.scss'
})
export class NewBillingComponent {
    @Input() confirmAction!: () => void;
    @Input() data: any;

    listBilling: any = [];

    public billingForm: FormGroup;
    items: any[] = [];
    cfdiUses: any[];

    isEdit: boolean = false;


    constructor(public modalService :NgbModal, private auth: AuthService, private generalService: GeneralService, private fb: FormBuilder, private tableService: TableService, private routesService: RoutesService, private billingService: BillingService){

        //Formulario
        this.billingForm = this.fb.group({
            id: [null],
            businessNames: ["", Validators.required], // Razón social
            client_data: 0,
            rfc: ["", Validators.required],
            fiscalAddress: ["", Validators.required],
            postalCode: ["", [Validators.required, Validators.pattern("^[0-9]{5}$")]],
            cfdiUse: ["", Validators.required],
            additionalEmail: [""],
            taxCertificate: [null, [Validators.required]],
            tax_url:[""]
        });
    }

    ngOnInit(): void {
        //Listas
        this.getUse();
        if(this.data && this.data.item){
            this.editRow(this.data.item);
        } else {
            this.newRow();
        }
    }

    getUse():void {
        //Uso comun
        this.loadList({"conditionColumn":"configurableListsField",
            "conditionValue":"Uso CFDI",
            "idColumn":"idconfigurableLists",
            "table":"confList",
            "valueColumn":"configurableListsCode"}, (value) => {this.cfdiUses = value;});
    }

    loadList(config: any, setVariable: (value: any) => void):void {
        this.tableService.loadSelectOptions(config).subscribe(
            (res: any) => {
                if (res.error) {
                    this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                    setVariable([]);
                } else {
                    setVariable(res['message']);
                }
            },
            (err) => {
                this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
                setVariable([]);
            }
        );
    }

    // Cargar archivo PDF
    selectedFile: File | null = null;
    onFileChange(event: any) {
        const file = event.target.files[0];
        if (file && file.type === "application/pdf") {
            this.selectedFile = file;
            this.billingForm.get("taxCertificate")?.setValue(file.name); // Guarda solo el nombre en el form
        } else {
            this.generalService.showMessage('warn', 'Error! Solo se permiten archivos PDF.');
            event.target.value = "";
        }
    }
    //Función para crear nuevo registro
    newRow(): void {
        this.isEdit = false;
        this.billingForm.get('taxCertificate')?.setValidators([Validators.required]);
        this.billingForm.get('taxCertificate')?.updateValueAndValidity();
        this.billingForm.patchValue({ client_data: this.data.idClient });
    }

    //Función para editar un registro
    isEditPDF = false;
    editRow(item: any): void{
        this.isEditPDF = false;
        this.isEdit = true;
        this.billingForm.get('taxCertificate')?.clearValidators();
        this.billingForm.get('taxCertificate')?.updateValueAndValidity();
        this.billingForm.setValue({
            id: item.id,
            businessNames: item.legal_names || "", // Razón social
            client_data: this.data.idClient,
            rfc: item.rfc,
            fiscalAddress: item.billing_address,
            postalCode: item.cp,
            cfdiUse: item.use_cfdi_id,
            additionalEmail: item.additional_email,
            taxCertificate: null,
            tax_url: item.tax_status_certificate_url
        });
    }

    downloadPDF(url: any = "") {
        let pdfUrl = "";
        if(url != ""){
            pdfUrl = url;
        } else {
            pdfUrl = this.billingForm.get('tax_url')?.value; // Obtener la URL del campo tax_url
        }
        if (pdfUrl) {
            window.open(pdfUrl, '_blank'); // Abre el PDF en una nueva ventana
        }
    }

    //Función para eliminar un registro
    deleteRow(item: any): void{
        let modal = this.modalService.open(ConfirmComponent, { centered: true });
        modal.componentInstance.image = "assets/images/gif/danger.gif";
        modal.componentInstance.title = "¿Estás seguro de que deseas eliminar este registro?";
        modal.componentInstance.description = "Esta acción no se puede deshacer. ¿Deseas continuar con la eliminación?";
        modal.componentInstance.refModel = modal;
        modal.componentInstance.confirmAction = () => {
            this.billingService.delete({id: item.id}).subscribe(
                (res: any) => {
                    if (res.error) {
                        this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                    } else {
                        this.generalService.showMessage('success', res.message);
                        modal.close();
                        this.confirmAction();
                    }
                },
                (err: any) => {
                    this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
                }
            );
        };
    }

    submitForm(): void {
        if (this.billingForm.valid) {
            const formData = new FormData();
            Object.keys(this.billingForm.value).forEach(key => {
                formData.append(key, this.billingForm.value[key]);
            });
            if (this.selectedFile) {
                formData.append("taxCertificate", this.selectedFile);
            }

            this.billingService.add(formData).subscribe(
                (res: any) => {
                    if (res.error) {
                        this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                    } else {
                        this.generalService.showMessage('success', res.message);
                        this.confirmAction();
                    }
                },
                (err: any) => {
                    this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
                }
            );
        } else {
            this.billingForm.markAllAsTouched();
            this.generalService.showMessage('warn', 'LLene toda la información solicitada');
        }
    }
}
